/**
 * @file useChatViewport.ts
 * @description Ширина экрана для раскладки окна «Сообщения»
 * (chat-window-design.md §1б–д): телефон < 768, планшет < 1024, ноутбук
 * < 1280, широкий экран.
 */

import { BELOW_LG_QUERY, PHONE_QUERY, WIDE_QUERY, useMediaQuery } from "../../hooks/useMediaQuery";
import type { ChatViewport } from "./chat-window-state";

export function useChatViewport(): ChatViewport {
  const phone = useMediaQuery(PHONE_QUERY);
  const belowLg = useMediaQuery(BELOW_LG_QUERY);
  const wide = useMediaQuery(WIDE_QUERY);
  if (phone) return "phone";
  if (belowLg) return "tablet";
  return wide ? "wide" : "desktop";
}
